export const formatMoney = (value?: string | number | null) => `$${Number(value || 0).toFixed(2)}`;

export const getStatusLabel = (status?: string) => {
    switch (status) {
        case 'completed':
            return 'Completed';
        case 'unpaid':
            return 'Pending';
        case 'incomplete':
            return 'Incomplete';
        case 'voided':
            return 'Voided';
        default:
            return status ?? '';
    }
};

export const formatItemType = (type: string) => {
    switch (type) {
        case 'add_on':
        case 'addon':
        case 'addon_service':
            return 'Add-On';
        case 'product':
            return 'Product';
        case 'custom':
            return 'Custom';
        default:
            return type || '-';
    }
};
